// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Raw Data Area
export class AreaRawData {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(dataCore) {
        this.dataCore = dataCore;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Fetch raw data
    /** Fetches raw data necessary for construction of components */
    getRawComponentModelData(designSystemId, versionId) {
        return this.dataCore.read.getRemoteComponents(designSystemId, versionId);
    }
    /** Fetches raw data necessary for component groups */
    getRawComponentGroupModelData(designSystemId, versionId) {
        return this.dataCore.read.getRemoteComponentGroups(designSystemId, versionId);
    }
    /** Fetches raw data necessary for assets */
    getRawAssetModelData(designSystemId, versionId) {
        return this.dataCore.read.getRemoteAssets(designSystemId, versionId);
    }
    /** Fetches raw data necessary for asset groups */
    getRawAssetGroupModelData(designSystemId, versionId) {
        return this.dataCore.read.getRemoteAssetGroups(designSystemId, versionId);
    }
    /** Fetches raw data necessary for tokens */
    getRawTokenModelData(designSystemId, versionId) {
        return this.dataCore.read.getRemoteTokens(designSystemId, versionId);
    }
    /** Fetches raw data necessary for token groups */
    getRawTokenGroupModelData(designSystemId, versionId) {
        return this.dataCore.read.getRemoteTokenGroups(designSystemId, versionId);
    }
    /** Fetches raw data necessary for elements */
    async getRawElementModelData(designSystemId, versionId) {
        const result = await Promise.all([
            this.dataCore.read.getRemoteElementPropertyValues(designSystemId, versionId),
            this.dataCore.read.getRemoteElementDataViewDefinitions(designSystemId, versionId),
            this.dataCore.read.getRemoteElementPropertyDefinitions(designSystemId, versionId),
        ]);
        return {
            propertyValues: result[0],
            propertyViews: result[1],
            propertyDefinitions: result[2],
        };
    }
    /** Fetches raw source data */
    getRawSourceModelData(designSystemId) {
        return this.dataCore.read.getRemoteSources(designSystemId);
    }
    /** Fetches raw font resources data */
    getRawFontResourcesModelData(designSystemId, versionId) {
        return this.dataCore.read.getRemoteFontResources(designSystemId, versionId);
    }
    /** Fetches raw membership */
    getRawMembershipModelData(userId) {
        return this.dataCore.read.getRemoteMemberships(userId);
    }
    /** Fetches raw design systems */
    getRawDesignSystemModelData(workspaceId) {
        return this.dataCore.read.getRemoteDesignSystems(workspaceId);
    }
    /** Fetches raw versions */
    getRawVersionModelData(designSystemId) {
        return this.dataCore.read.getVersions(designSystemId);
    }
    /** Fetches raw brands */
    getRawBrandModelData(designSystemId, versionId) {
        return this.dataCore.read.getBrands(designSystemId, versionId);
    }
    /** Fetches raw current user */
    getRawCurrentUserModelData() {
        return this.dataCore.read.getRemoteCurrentUser();
    }
    /** Fetches raw user memberships */
    getRawWorkspaceMemberships(workspaceId) {
        return this.dataCore.read.getRemoteUserMemberships(workspaceId);
    }
    /** Fetches raw design components */
    getRawDesignComponentModelData(designSystemId, versionId, filter) {
        return this.dataCore.read.getRemoteDesignComponents(designSystemId, versionId, filter);
    }
    /** Fetches raw design component groups */
    getRawDesignComponentGroupModelData(designSystemId, versionId, filter) {
        return this.dataCore.read.getRemoteDesignComponentGroups(designSystemId, versionId, filter);
    }
    getRawStorybookEntries(designSystemId, versionId) {
        return this.dataCore.read.getStorybookEntries(designSystemId, versionId);
    }
    getRawDocumentationStructure(designSystemId, versionId) {
        return this.dataCore.read.getRemoteRealDocumentationStructure(designSystemId, versionId);
    }
    getRawDocumentationBuilds(workspaceId, versionId, environment, status, createdByUserId, limit = 1) {
        return this.dataCore.read.getRemoteBuilds(workspaceId, versionId, environment, limit, 0, undefined, undefined, ["documentation"], createdByUserId, status);
    }
}
